import { useChatContext } from '../ChatContext';
import CollaboratorChat from './CollaboratorChat';
import CollaboratorChatHeader from './CollaboratorChatHeader';
import { CollaboratorContainer } from './CollaboratorChatbox.styles';

const CollaboratorChatbox = () => {
  const { isCollapsed } = useChatContext();

  return (
    <CollaboratorContainer
      data-name="conversations-container"
      flex={isCollapsed ? '0' : '1 1 100%'}
      height="100%"
    >
      <CollaboratorChatHeader />
      <CollaboratorChat />
    </CollaboratorContainer>
  );
};

export default CollaboratorChatbox;
